<template>
  <div>
    <DeviceInfoDialog
      :deviceId="deviceId"
      :open="dialogs.info"
      @close="closeDialog('info')"
      @after-leave="dialogClosed('info')"
    />
    <DeviceSettingsDialog
      :deviceId="deviceId"
      :permissions="permissions"
      :open="dialogs.settings"
      @close="closeDialog('settings')"
      @after-leave="dialogClosed('settings')"
    />
    <DeviceAlertsDialog
      :deviceId="deviceId"
      :permissions="permissions"
      :open="dialogs.alerts"
      @close="closeDialog('alerts')"
      @after-leave="dialogClosed('alerts')"
    />
    <DeviceSharingDialog
      :deviceId="deviceId"
      :permissions="permissions"
      :open="dialogs.sharing"
      @close="closeDialog('sharing')"
      @after-leave="dialogClosed('sharing')"
    />
    <HistoryDialog
      :currentDeviceId="historyCurrentDeviceId"
      :isDetachedDialog="false"
      :removableDevices="false"
      :open="dialogs.history"
      :scrim="true"
      @close="closeDialog('history')"
      @after-leave="dialogClosed('history')"
    />
    <CurrentReadingsDialog
      :currentDeviceId="deviceId"
      :open="dialogs.currentReadings"
      :scrim="true"
      @close="closeDialog('currentReadings')"
      @after-leave="dialogClosed('currentReadings')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import CurrentReadingsDialog from '@/components/dialogs/CurrentReadingsDialog.vue'
import DeviceInfoDialog from '@/components/dialogs/deviceInfo/DeviceInfoDialog.vue'
import DeviceSettingsDialog from '@/components/dialogs/DeviceSettingsDialog.vue'
import DeviceSharingDialog from '@/components/dialogs/DeviceSharingDialog.vue'
import DeviceAlertsDialog from '@/components/dialogs/DeviceAlertsDialog.vue'
import HistoryDialog from '@/components/dialogs/HistoryDialog.vue'
import { getPermissionsByDeviceId } from '@/services/subscriptions'

type DeviceDialogKey = 'info' | 'settings' | 'alerts' | 'sharing' | 'history' | 'currentReadings'

export default defineComponent({
  name: 'DeviceActionMenuDialogs',
  props: {
    deviceId: String,
    dialog: String
  },
  emits: ['closeDialog'],
  data() {
    return {
      dialogs: {
        info: false,
        settings: false,
        alerts: false,
        sharing: false,
        history: false,
        currentReadings: false
      },
      historyCurrentDeviceId: null as string | null
    }
  },
  components: {
    CurrentReadingsDialog,
    DeviceInfoDialog,
    DeviceSettingsDialog,
    DeviceSharingDialog,
    DeviceAlertsDialog,
    HistoryDialog
  },
  mounted() {
    this.openDialog()
  },
  watch: {
    dialog(dialog: string) {
      if (dialog) {
        this.openDialog()
      }
    }
  },
  methods: {
    async openDialog(): Promise<void> {
      if (this.dialog && this.deviceId) {
        if (this.dialog === 'history') {
          await this.openHistoryDialog(this.deviceId)
          return
        }
        this.dialogs[this.dialog as DeviceDialogKey] = true
      }
    },
    async openHistoryDialog(deviceId: string): Promise<void> {
      this.historyCurrentDeviceId = deviceId
      this.dialogs.history = true
      await this.$nextTick()
      this.historyCurrentDeviceId = null
    },
    closeDialog(dialog: DeviceDialogKey): void {
      this.dialogs[dialog] = false
    },
    dialogClosed(dialog: DeviceDialogKey): void {
      this.$emit('closeDialog', dialog)
    }
  },
  computed: {
    permissions() {
      return getPermissionsByDeviceId(this.deviceId)
    }
  }
})
</script>
